module.exports = __webpack_public_path__ + "img/charge-table.3c45f968.png";